import {
  AuthEffects,
  ChatEffects,
  CustomerProfileEffects,
  InvoiceEffects,
  MeetingAvailabilityEffects,
  MeetingTypeEffects,
  OfferedServiceEffects,
  OrderCardAttributeEffects,
  OrderCardAttributeTypeEffects,
  OrderCardEffects,
  OrderEffects,
  OrderServiceLinkageEffects,
  OrderStatusEffects,
  ScheduledMeetingEffects,
} from '@aa/angular/core';

export const customerAppEffects = [
  AuthEffects,
  ChatEffects,
  OrderEffects,
  OrderCardEffects,
  OfferedServiceEffects,
  OrderServiceLinkageEffects,
  OrderStatusEffects,
  OrderCardAttributeEffects,
  OrderCardAttributeTypeEffects,
  InvoiceEffects,
  CustomerProfileEffects,
  MeetingTypeEffects,
  ScheduledMeetingEffects,
  MeetingAvailabilityEffects,
];
